import { atomWithQuery } from 'jotai-tanstack-query';
import { ISelfResponse } from '@/shared/interfaces';
import { fetchProfile } from '@/api/profile/fetchProfile';

export const fetchProfileQueryAtom = atomWithQuery<ISelfResponse | undefined>(
    () => ({
        queryKey: ['profile'],
        queryFn: async () => {
            return fetchProfile();
        },
        initialData: undefined,
        enabled: false, // avoid initial fetch
    }),
);
